export const validateName = (_: any, value: any) => {
  const nameRegex = /^[a-zA-Z\s]{2,26}$/;
  if (value && !nameRegex.test(value)) {
    return Promise.reject(
      new Error("Debe contener de 2 a 26 letras alfanuméricas")
    );
  }
  return Promise.resolve();
};
